export const actionTypes = {
  UNREGISTER_DELETE_REQUEST: 'UNREGISTER_DELETE_REQUEST',
  UNREGISTER_DELETE_SUCCESS: 'UNREGISTER_DELETE_SUCCESS',
  UNREGISTER_DELETE_FAILURE: 'UNREGISTER_DELETE_FAILURE',

  UNREGISTER_REMAIN_REQUEST: 'UNREGISTER_REMAIN_REQUEST',
  UNREGISTER_REMAIN_SUCCESS: 'UNREGISTER_REMAIN_SUCCESS',
  UNREGISTER_REMAIN_FAILURE: 'UNREGISTER_REMAIN_FAILURE',
};

export const unregisterDeleteRequest = () => ({
  type: actionTypes.UNREGISTER_DELETE_REQUEST,
});

export const unregisterDeleteSuccess = (data) => ({
  type: actionTypes.UNREGISTER_DELETE_SUCCESS,
  payload: data,
});

export const unregisterDeleteFailure = (error) => ({
  type: actionTypes.UNREGISTER_DELETE_FAILURE,
  payload: error,
});

export const unregisterRemainRequest = () => ({
  type: actionTypes.UNREGISTER_REMAIN_REQUEST,
});

export const unregisterRemainSuccess = (data) => ({
  type: actionTypes.UNREGISTER_REMAIN_SUCCESS,
  payload: data,
});

export const unregisterRemainFailure = (error) => ({
  type: actionTypes.UNREGISTER_REMAIN_FAILURE,
  payload: error,
});